/*******************************Custom JS CHILD***********************************/
(function ($) {

  
  
/******************/  
/****HEADER NAV****/
/******************/
  
/*active nav if active child*/
$(document).ready(function(){
  if ($(".dropdown-menu li").hasClass("site-nav--active")) {
      $(".nav-pills .dropdown").addClass("site-nav--active");
  }
});
  
/*prevent click dorpdown*/
$(document).ready(function() {
    $('.dropdown-envy-toggle').click(function() {
        return false;
    });
});
  
/*decoration line*/
$(document).ready(function() {
  	$(".header-menu-wrapper").prepend('<span class="nav_decoration"></span>')
});

/*Nav mobile*/
$(function() {
  	/*open menu*/
    $(document).on("click", ".slide-menu-mobile", function(){
      	$(".mobile-menu--wrapper").removeClass("slideout-panel-hidden");
		$("#main-body").addClass("main-body_mobile-hidden");
      	$("#slideout-overlay").css("display", "block");
    });
	/*close menu*/
  	$(document).on("click", ".mobile-menu-close", function(){
		$(".mobile-menu--wrapper").addClass("slideout-panel-hidden");
      	$("#main-body").removeClass("main-body_mobile-hidden");
      	$("#slideout-overlay").css("display", "none");
    });
});
  

  
/**********************/  
/****PRODUCT SINGLE****/
/**********************/
$(document).ready(function() {
	$('#sharing').prepend('<div class="title-bar title-bar-lowercase custom-font"><h2>Share</h2><div class="clear"></div></div>');
});
/*resize img anim with parent*/
$(document).ready(function() {
  	var galleryHeight = $("#product_images .featured-image-div").height();
  
	$("#product_images .featured-image-div div").css("min-height", galleryHeight);
});
$(window).resize(function(){
  	var galleryHeight = $("#product_images .featured-image-div").height();
  
	$("#product_images .featured-image-div div").css("min-height", galleryHeight);
});

/****RECOMMENDED(PLUGIN)****/ 
$(function() {
  var checkExist = setInterval(function() {
     if ($(".ot-related-product-list").length) {
        $('.ot-related-product-list').prepend('<div class="title-bar title-bar-lowercase custom-font"><h2>You may also like</h2><div class="clear"></div></div>');
       	$('.ot-related-product-title a').attr("tabindex", "-1");
        clearInterval(checkExist);
     }
  }, 100);
});
  
/****SOLD OUT****/ 
$(document).ready(function() {
	$('.product-out-of-stock').append('<p class="stock-notice">Back in stock soon</p>');
});  
  
  
/***************/  
/****CONTACT****/
/***************/
/*
$(document).ready(function() {
	$('#contact article#contact').prepend('<div class="img-header"><img src="//ericbuterbaugh.com/cdn/shop/t/2/assets/header-contact-img.jpg?v=22013074901230626761566833869" alt="Photograph a bit out of focus of Hollywood hills, with the sign in the background."></div>');
});
*/
  
  
/**************/  
/****FOOTER****/
/**************/
$(document).ready(function() {
	$('.links-footer, .mailing-list-footer').removeClass("col-md-3");
  	$('.image-footer, .content-footer').addClass("col-md-12").removeClass("col-md-3 col-sm-6");
  	$('#shopify-section-footer').prepend('<div class="footer-img-anim footer-img-anim-left"></div>');
    $('#shopify-section-footer').prepend('<div class="footer-img-anim footer-img-anim-right"></div>');
});
/*resize img anim with parent*/
$(document).ready(function() {
  	var galleryHeight = $("#shopify-section-footer").height();
  
	$(".footer-img-anim").css("height", galleryHeight);
});
$(window).resize(function(){
  	var galleryHeight = $("#shopify-section-footer").height();
  
	$(".footer-img-anim").css("height", galleryHeight);
});

/*provisional*/
$(function() {
  var checkExist = setInterval(function() {
     if ($("#newsletter_text").length) {
       	$("#newsletter_text").attr( "placeholder", "Coming soon" );
        clearInterval(checkExist);
     }
  }, 100);
}); 
  
/******************/
/**ADA COMPLIANCE**/
/******************/
  
$(document).ready(function() {
	$('[id="newsletter_submit"]').attr( { 'aria-label':"newsletter_submit", role:"button" } );
  	$('[id="search_submit"]').attr( { 'aria-label':"search_submit", role:"button" } );
  	$('[id="search_submit__bar"]').attr( { 'aria-label':"search_submit", role:"button" } );
  	$('[id="search_submit__bar-sticky"]').attr( { 'aria-label':"search_submit", role:"button" } );
	$('[id="search_text"]').attr( { 'aria-label':"search_text", placeholder:"Search..." } );
  	$('[id="search_text__bar"]').attr( { 'aria-label':"search_text", placeholder:"Search..." } );
  	$('[id="search_text__bar-sticky"]').attr( { 'aria-label':"search_text", placeholder:"Search..." } );
  	$('[href="https://www.instagram.com/ericbuterbaughfragrances/"]').attr( 'aria-label', "Instagram (New Window)" );
  	$('[href="https://www.instagram.com/ericbuterbaughla/"]').attr( 'aria-label', "Instagram (New Window)" );
  	$('[href="https://www.instagram.com/ericbuterbaugh/"]').attr( 'aria-label', "Instagram (New Window)" );
  	$(".instagram-indiv a").attr( 'aria-label', "Instagram (New Window)" );
  	$(".instagram-indiv a img").attr( 'alt', "Instagram image @EricButerbaughFragrances" );
    $('[itemprop="logo"]').attr( 'alt', "Logo Eric Buterbaugh - Los Angeles" );
  	$(".footer-image-id--1565786315788 img").attr( 'alt', "Logo icon Eric Buterbaugh - EST. 2015" );
    $("svg").removeAttr("role").attr( { 'aria-hidden':"true", role:"presentation" } );
  	$('svg circle, svg rect, svg line, svg path').attr( "aria-hidden", "true" );
  	$("#xo-scroll2top").attr( 'aria-label', "Scroll to top" );
  	$(".quantity-selector").attr( 'aria-label', "Quantity selector" );
  	$(".footer-image-id--1580973522687 a").attr( 'aria-label', "Home link" );
  	$(".crossed-out").attr( 'alt', "Sold out" );
});
  
/*DUPLICATE ID´s*/
  
/*Search bar*/
$(document).ready(function() {
	$(".sticky-header-search #search-page-form__bar").attr("id", "search-page-form__bar-sticky");
  	$(".sticky-header-search #search-page-form").attr("id", "search-page-form-sticky");
  	$(".sticky-header-search #search-wrapper__bar").attr("id", "search-wrapper__bar-sticky");
  	$(".sticky-header-search #search-wrapper").attr("id", "search-wrapper-sticky");
  	$(".mobile-search #search-wrapper").attr("id", "search-wrapper-mobile");
  	$(".sticky-header-search #search_text__bar").attr("id", "search_text__bar-sticky");
  	$(".sticky-header-search #search_text").attr("id", "search_text-sticky");
  	$(".mobile-search #search_text").attr("id", "search_text-mobile");
  	$(".sticky-header-search #search_submit__bar").attr("id", "search_submit__bar-sticky");
  	$(".sticky-header-search #search_submit").attr("id", "search_submit-sticky");
});
  
/*Header*/
$(document).ready(function() {
	$(".sticky-header-wrapper #main-navigation-wrapper").attr("id", "main-navigation-wrapper__sticky");
    $(".mobile-header-wrap .mobile-header-wrap--icons #site-title").attr("id", "site-title__mobile");
  	$(".sticky-mobile-header .mobile-header-wrap--icons #site-title").attr("id", "site-title__mobile-sticky");
 	$(".sticky-mobile-header .slide-menu-mobile svg").attr("id", "iconAnim__sticky");
  	$(".mobile-social-icons-list #sm-icons").attr("id", "sm-icons__mobile");
  	$(".mobile-social-icons-list #sm-instagram").attr("id", "sm-instagram__mobile");
});
  
/*Single Product*/
/*$(document).ready(function() {
	$("#mobile-product-images #product-thumbnails").attr("id", "product-thumbnails-mobile");
});*/
  
/*User account and cart*/
$(document).ready(function() {
	$("#customer #first_name.large_form").attr("id", "first_name_content");
  	$("#customer #last_name.large_form").attr("id", "last_name_content");
    $("#customer #password.large_form").attr("id", "password_content");
    $("#customer #email.large_form").attr("id", "email_content");
  	$(".form-group #agree").attr("id", "form-agree");
});
  
/*buddha-menu*/
$(document).ready(function() {
	$(".mm-contact-content #contact_form").attr("id", "mm_contact_form");
});
   
  
/****COLLECTIONS****/
$(document).ready(function() {
    $('.hp-title a').attr('tabindex', '-1');
});
  
/*FILTER*/
$(document).ready(function() {
    $("label[for=sort-by]").empty().append("Sort by:");
  	$('input[class=select-dropdown]').attr( 'aria-label', "Dropdown" );
});
   

/*Outline keyboard*/
$(document).mousedown(function(event) { 
	$("body").removeClass("using-keyboard");
});  
$(document).keydown(function(event) { 
	$("body").addClass("using-keyboard");
});

  
/*Product single*/
$(document).ready(function() {
  $('.share-facebook').attr( 'aria-label', "Share Facebook (New Window)" );
  $('.share-twitter').attr( 'aria-label', "Share Twitter (New Window)" );
  $('.share-pinterest').attr( 'aria-label', "Share Pinterest (New Window)" );
});
  
  
/*Instagram - instafeed plugin*/
$(function() {
    $(document).on("click", ".instafeed-shopify a, #insta-feed a", function(){
		if($('.instafeed-lightbox').is(':hidden')){
          	$(".lightbox-instagram a[target='_blank']").attr( 'aria-label', "Instagram (New Window)" );
          	$(".lightbox-instagram object").attr( 'aria-label', "Instagram button" );
          	$(".lightbox-instagram object").attr( 'classid', "InstagramButton" );
      	}
    });
}); 
 
  
/*Newsletter - secomapp plugin*/
$(function() {
  var checkExist = setInterval(function() {
     if ($(".subcrible-text").length) {
       	$(".subcrible-text").attr( { 'title':"Your email address", placeholder:"Your email address" } );
        clearInterval(checkExist);
     }
  }, 100);
});  

  
/*Store locator map - Develic plugin*/
$(function() {
  var imgPoint = 'img[src$="https://maps.develic.com/utils/markers/591b71091bc3ca459764a4f9347de8c61716a686.png"]';
  var checkExist = setInterval(function() {
     if ($(imgPoint).length) {
       	$(".develic-search-input").attr("title", "Filter by title or description"); //Add title to filter input
       	$(".develic-map a[target='_blank']").attr( 'aria-label', "Store locator (New Window)" ); //target blank links
       	$(".develic-map img").attr( 'alt', "Store locator element" );
        $(imgPoint).attr( 'alt', "Store point" );
        clearInterval(checkExist);
     }
  }, 100);
});
  
$(function() {
  var imgZoomIn1 = 'img[src$="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%3E%0A%20%20%3Cpolygon%20fill%3D%22%23666%22%20points%3D%2218%2C7%2011%2C7%2011%2C0%207%2C0%207%2C7%200%2C7%200%2C11%207%2C11%207%2C18%2011%2C18%2011%2C11%2018%2C11%22%2F%3E%0A%3C%2Fsvg%3E%0A"]';
  var imgZoomIn2 = 'img[src$="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%3E%0A%20%20%3Cpolygon%20fill%3D%22%23333%22%20points%3D%2218%2C7%2011%2C7%2011%2C0%207%2C0%207%2C7%200%2C7%200%2C11%207%2C11%207%2C18%2011%2C18%2011%2C11%2018%2C11%22%2F%3E%0A%3C%2Fsvg%3E%0A"]';
  var imgZoomIn3 = 'img[src$="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%3E%0A%20%20%3Cpolygon%20fill%3D%22%23111%22%20points%3D%2218%2C7%2011%2C7%2011%2C0%207%2C0%207%2C7%200%2C7%200%2C11%207%2C11%207%2C18%2011%2C18%2011%2C11%2018%2C11%22%2F%3E%0A%3C%2Fsvg%3E%0A"]';
  var checkExist = setInterval(function() {
     if ($(imgZoomIn1).length) {
       	$(imgZoomIn1).attr( 'alt', "Zoom in map" );
       	$(imgZoomIn2).attr( 'alt', "Zoom in map" );
       	$(imgZoomIn3).attr( 'alt', "Zoom in map" );
        clearInterval(checkExist);
     }
  }, 100);
});
$(function() {
  var imgZoomOut1 = 'img[src$="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%3E%0A%20%20%3Cpath%20fill%3D%22%23666%22%20d%3D%22M0%2C7h18v4H0V7z%22%2F%3E%0A%3C%2Fsvg%3E%0A"]';
  var imgZoomOut2 = 'img[src$="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%3E%0A%20%20%3Cpath%20fill%3D%22%23333%22%20d%3D%22M0%2C7h18v4H0V7z%22%2F%3E%0A%3C%2Fsvg%3E%0A"]';
  var imgZoomOut3 = 'img[src$="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%3E%0A%20%20%3Cpath%20fill%3D%22%23111%22%20d%3D%22M0%2C7h18v4H0V7z%22%2F%3E%0A%3C%2Fsvg%3E%0A"]';
  var checkExist = setInterval(function() {
     if ($(imgZoomOut1).length) {
       	$(imgZoomOut1).attr( 'alt', "Zoom out map" );
       	$(imgZoomOut2).attr( 'alt', "Zoom out map" );
       	$(imgZoomOut3).attr( 'alt', "Zoom out map" );
        clearInterval(checkExist);
     }
  }, 100);
});

$(document).on("click", ".develic-map div[style*='touch-action: none'], .develic-map span[role='checkbox'], .develic-map div[role='button'], .develic-map div[draggable='false'], .develic-map button", function(){
  var imgZoomIn1 = 'img[src$="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%3E%0A%20%20%3Cpolygon%20fill%3D%22%23666%22%20points%3D%2218%2C7%2011%2C7%2011%2C0%207%2C0%207%2C7%200%2C7%200%2C11%207%2C11%207%2C18%2011%2C18%2011%2C11%2018%2C11%22%2F%3E%0A%3C%2Fsvg%3E%0A"]';
  var imgZoomIn2 = 'img[src$="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%3E%0A%20%20%3Cpolygon%20fill%3D%22%23333%22%20points%3D%2218%2C7%2011%2C7%2011%2C0%207%2C0%207%2C7%200%2C7%200%2C11%207%2C11%207%2C18%2011%2C18%2011%2C11%2018%2C11%22%2F%3E%0A%3C%2Fsvg%3E%0A"]';
  var imgZoomIn3 = 'img[src$="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%3E%0A%20%20%3Cpolygon%20fill%3D%22%23111%22%20points%3D%2218%2C7%2011%2C7%2011%2C0%207%2C0%207%2C7%200%2C7%200%2C11%207%2C11%207%2C18%2011%2C18%2011%2C11%2018%2C11%22%2F%3E%0A%3C%2Fsvg%3E%0A"]';
  var imgZoomOut1 = 'img[src$="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%3E%0A%20%20%3Cpath%20fill%3D%22%23666%22%20d%3D%22M0%2C7h18v4H0V7z%22%2F%3E%0A%3C%2Fsvg%3E%0A"]';
  var imgZoomOut2 = 'img[src$="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%3E%0A%20%20%3Cpath%20fill%3D%22%23333%22%20d%3D%22M0%2C7h18v4H0V7z%22%2F%3E%0A%3C%2Fsvg%3E%0A"]';
  var imgZoomOut3 = 'img[src$="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%3E%0A%20%20%3Cpath%20fill%3D%22%23111%22%20d%3D%22M0%2C7h18v4H0V7z%22%2F%3E%0A%3C%2Fsvg%3E%0A"]';
  var imgPoint = 'img[src$="https://maps.develic.com/utils/markers/591b71091bc3ca459764a4f9347de8c61716a686.png"]';
	var imgPointClose2 = '.gm-style-iw-a .gm-ui-hover-effect img';
  
  $(function() {
    $(".develic-map a[target='_blank']").attr( 'aria-label', "Store locator (New Window)" ); //target blank links
    $(".develic-map img").attr( 'alt', "Store locator element" );
    $(imgPoint).attr( 'alt', "Store point" );
    $(imgPointClose2).attr( 'alt', "Close store window" );
    $(imgZoomIn1).attr( 'alt', "Zoom in map" );
  	$(imgZoomIn2).attr( 'alt', "Zoom in map" );
  	$(imgZoomIn3).attr( 'alt', "Zoom in map" );
    $(imgZoomOut1).attr( 'alt', "Zoom out map" );
    $(imgZoomOut2).attr( 'alt', "Zoom out map" );
    $(imgZoomOut3).attr( 'alt', "Zoom out map" );
  });
});
  
  
$(function() {
  var imgPointClose1 = '.gm-ui-hover-effect img';
  var imgPointClose2 = '.gm-style-iw-a .gm-ui-hover-effect img';
  var checkExist = setInterval(function() {
     if ($(imgPointClose1).length) {
       	$(imgPointClose1).attr( 'alt', "Close store window" );
        $(imgPointClose2).attr( 'alt', "Close store window" );
        clearInterval(checkExist);
     }
  }, 100);
});
  
$(function() {
  var imgPointClose2 = '.gm-style-iw-a .gm-ui-hover-effect img';
  var checkExist2 = setInterval(function() {
     if ($(imgPointClose2).length) {
        $(imgPointClose2).attr( 'alt', "Close store window" );
        clearInterval(checkExist2);
     }
  }, 100);
});

 
/*Cookie Bar (Free GDPR + Cookie Management)*/
$(function() {
  var checkExist = setInterval(function() {
     if ($(".cc-message").length) {
       	  	$('.cc-link').attr( 'aria-label', "learn more about cookies (New Window)" );
     }
  }, 100);
});  
  

  
  
  
/*******************************Custom JS CHILD***********************************/
})(window.wetheme.$);